import React from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import type { FormBadgeListProps } from '@gov-nx/ui/types';
import { Tabs } from '../Tabs';

type FormTabsProps = FormBadgeListProps;

export const FormTabs = (props: FormTabsProps) => {
	const { control } = useFormContext();

	return (
		<Controller
			name={props.field.name}
			control={control}
			render={({ field }) => (
				<Tabs
					type="text"
					items={props.options.map((option) => ({
						label: option.label,
						isActive: !!field.value?.[option.name],
						triggerIdentifier: option.name,
						// eslint-disable-next-line react/jsx-no-useless-fragment
						children: <></>,
					}))}
					onChange={(identifier) => {
						const updated = props.options.reduce(
							(all, current) => ({
								...all,
								[current.name]: identifier === current.name,
							}),
							{}
						);
						field.onChange(updated);
						field.onBlur();
					}}
				/>
			)}
		/>
	);
};
